import { ScopeOption } from '../types';

// Значение по умолчанию совпадает с DEFAULT_LIMIT в backend/services/staffAccounts.js
const DEFAULT_STAFF_LIMIT = 10;

const staffLimitScope = (values: number[]): ScopeOption[] => [
  ...values.map(v => ({
    value: String(v),
    label: `${v} учёток`,
    description: `У точки может быть не больше ${v} активных подчинённых. Заблокированные не считаются`,
    badgeColor: '#3b82f6'
  })),
  {
    value: 'none',
    label: `По умолчанию (${DEFAULT_STAFF_LIMIT})`,
    description: `Настройка выключена - действует лимит по умолчанию: ${DEFAULT_STAFF_LIMIT}`,
    badgeColor: '#6b7280'
  }
];

/**
 * Варианты скоупов подчинённых учёток точек: лимит мастера (staff.*, кабинет)
 * и зона видимости точек в «Пользователях» (users.staff.*, админка)
 */
export const staffScopes: Record<string, ScopeOption[]> = {
  'staff.create.limit': staffLimitScope([3, 5, 10, 20, 50]),

  'users.staff.view': [
    { value: 'all', label: 'Все точки', description: 'Подчинённые учётки всех аптек и складов сети', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Только точки из myPharmacy оператора', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Только точки своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'Подчинённые учётки не показываются', badgeColor: '#ef4444' }
  ]
};
